import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './auth.config';
function createMsalInstance(): PublicClientApplication | null {
  if (typeof window === 'undefined') {
    return null;
  }
  return new PublicClientApplication(msalConfig);
}

export const msalInstance = createMsalInstance()!;

